import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import HeadlineStyling from '../styles/headline';
import type { fontSizeTypes } from '../types';
import Text from './Text';

const StyledText = styled(Text)`
    ${HeadlineStyling};

    ${({ theme }) => (theme as any).Headline}
`;

type HeadingTypes = 'h1' | 'h2' | 'h3' | 'h4' | 'span' | 'div';
type HeadingSize = '3XL' | '2XL' | 'XL' | 'L' | 'M' | 'S';

export interface IHeadline extends HTMLAttributes<HTMLHeadingElement> {
    as?: HeadingTypes;
    size: HeadingSize;
}

const headlineSizeMap: Record<HeadingSize, fontSizeTypes> = {
    '3XL': { xs: 48, lg: 56 },
    '2XL': { xs: 40, lg: 48 },
    XL: { xs: 32, lg: 40 },
    L: { xs: 24, lg: 32 },
    M: { xs: 20, lg: 24 },
    S: { xs: 18, lg: 20 }
};

export default function Headline(props: IHeadline): JSX.Element {
    const { as = 'div', size, children, ...restProps } = props;

    return (
        <StyledText forwardedAs={as} size={headlineSizeMap[size]} {...restProps}>
            {children}
        </StyledText>
    );
}
